import { useParams } from 'react-router-dom';
import './WideMode.scss';

export const WideMode = ({ left, right }) => {
    const { spellId } = useParams();

    console.log(spellId)

    return (
        <div className="WideMode">
            <div className="left">
               {left}
            </div>
            <div className="right">
                {right}
            </div>
        </div>
    );
};